module.exports = __webpack_public_path__ + "img/card_icon_one.4f8d5448.png";